import { ProjectActivities } from '../redux/actions/projectActions/types';

/**
 * Normalizes notification payloads from GET /projects/notifications.
 *
 * Bug context (892): ProductAdded rows were not rendered because ProjectAuthorNotifications
 * groups by projectProductId, while the API often only sends projectProduct.id on the nested object.
 */
export const normalizeNotificationActivities = (
    activities: Array<ProjectActivities>,
): Array<ProjectActivities> => {
    return activities.map((day) => ({
        ...day,
        authors: day.authors.map((author) => ({
            ...author,
            activities: author.activities.map((activity) => ({
                ...activity,
                projectProductId: activity.projectProductId ?? activity.projectProduct?.id,
            })),
        })),
    }));
};
